interface LoadingSkeletonProps {
  count?: number;
  showUncategorized?: boolean;
}

export const LoadingSkeleton = ({ 
  count = 3, 
  showUncategorized = true 
}: LoadingSkeletonProps) => {
  return (
    <div className="animate-pulse">
      <div className="grid grid-flow-row md:grid-flow-col-dense md:auto-cols-fr">
        {/* Uncategorized section skeleton */}
        {showUncategorized && (
          <div className="w-full order-first md:order-last">
            <div className="border-t-2 border-gray-200 -mx-4 md:mx-6" />
            <div className="md:px-6 pt-4 bg-white">
              <div className="flex items-center justify-between py-2">
                <div className="h-6 bg-gray-200 rounded w-36" />
                <div className="h-6 w-6 bg-gray-200 rounded" />
              </div>
              <div className="h-4 bg-gray-200 rounded w-full max-w-md mb-2" />
            </div>
            <div className="px-2 space-y-2">
              <div className="h-20 bg-gray-100 rounded-lg" />
              <div className="h-20 bg-gray-100 rounded-lg" />
            </div>
            <div className="pb-4" />
            <div className="border-b-2 border-gray-200 -mx-10 md:mx-2 hidden md:block" />
          </div>
        )}

        {/* Custom sections skeleton */}
        <div className="w-full order-last md:order-first">
          <div className="border-t-2 border-gray-200 -mx-4 md:mx-6" />
          
          {Array.from({ length: count }).map((_, index) => (
            <div key={index} className="relative px-0 w-full">
              <div className="w-full">
                <div className="pl-2 md:pl-5 w-full bg-white rounded-2xl">
                  {/* Section Header Skeleton */}
                  <div className="flex items-center py-4">
                    <div className="h-6 w-6 bg-gray-200 rounded mr-2" />
                    <div className="flex items-center justify-between flex-1 py-2 pr-4 pl-2">
                      <div className="h-6 bg-gray-200 rounded w-40" />
                      <div className="flex items-center space-x-2">
                        <div className="h-6 bg-gray-200 rounded w-12" />
                        <div className="h-6 w-6 bg-gray-200 rounded" />
                      </div>
                    </div>
                  </div>
                  
                  {/* Section Content Skeleton */}
                  <div className="md:-ml-4 mr-4 space-y-3 pb-4">
                    <div className="h-16 bg-gray-100 rounded-lg" />
                    <div className="h-16 bg-gray-100 rounded-lg" />
                    <div className="h-10 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200" />
                  </div>
                </div>
                
                {/* Section border */}
                <div className="border-b-2 border-gray-200 -mx-10 md:mx-2" />
              </div>
            </div>
          ))}
          
          {/* Add category button skeleton */}
          <div className="flex justify-center mt-4 pl-8">
            <div className="h-10 bg-gray-200 rounded w-32" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const SectionItemSkeleton = () => (
  <div className="animate-pulse bg-white rounded-2xl p-4 border border-gray-100">
    <div className="flex items-center mb-4">
      <div className="h-6 w-6 bg-gray-200 rounded mr-3" />
      <div className="flex-1 flex items-center justify-between">
        <div className="h-6 bg-gray-200 rounded w-40" />
        <div className="flex items-center space-x-2">
          <div className="h-6 w-6 bg-gray-200 rounded" />
          <div className="h-6 w-6 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
    <div className="space-y-3 ml-9">
      <div className="h-16 bg-gray-100 rounded-lg" />
      <div className="h-16 bg-gray-100 rounded-lg" />
    </div>
  </div>
); 